<mat-toolbar color="accent"
  class="toolbar">
  <mat-toolbar-row class="username"
    tabindex="0">
    {{username}}
  </mat-toolbar-row>
</mat-toolbar>

<mat-nav-list class="nav-list">
  @for (navigationItem of navigationItems; track navigationItem.path) {
    <mat-list-item
      [routerLink]="navigationItem.path"
      (keyup.enter)="onKeyPressed(navigationItem)"
      (click)="onClickNavigationItem(navigationItem)">
      <mat-icon matListItemIcon
                [matBadge]="navigationItem.badgeCount"
                matBadgeColor="accent"
                matBadgeSize="small"
                [matBadgeHidden]="!navigationItem.badgeCount">
        {{navigationItem.icon}}
      </mat-icon>
      <a matListItemTitle>{{navigationItem.displayName}}</a>
    </mat-list-item>
  }
</mat-nav-list>
